import { ApolloClient, InMemoryCache } from '@apollo/client';
import { setContext } from 'apollo-link-context';
import { HttpLink } from 'apollo-link-http';

import {
  getCurrentToken,
  getEnv,
  getRegion,
  ENVS,
  REGIONS,
} from '@adsk/acs-sc-web-platform-api';

const GRAPHQL_HOST = {
  [REGIONS.US]: {
    [ENVS.QA]: 'https://plangrid-dev.planfront.net/proxy/graphql/graphql',
    [ENVS.STAGING]: 'https://plangrid-test.planfront.net/proxy/graphql/graphql',
    [ENVS.PRODUCTION]: 'https://app.plangrid.com/proxy/graphql/graphql',
  },
  [REGIONS.EMEA]: {
    [ENVS.QA]: 'https://plangrid-dev.planfront.net/proxy/graphql/graphql',
    [ENVS.STAGING]: 'https://plangrid-test.planfront.net/proxy/graphql/graphql',
    [ENVS.PRODUCTION]: 'https://app.plangrid.be/proxy/graphql/graphql',
  },
  [REGIONS.APAC]: {
    [ENVS.QA]: 'https://plangrid-dev.planfront.net/proxy/graphql/graphql',
    [ENVS.STAGING]: 'https://app.aus-stg.planfront.net/proxy/graphql/graphql',
    [ENVS.PRODUCTION]: 'https://app.plangrid.com.au/proxy/graphql/graphql',
  },
  [REGIONS.AUS]: {
    [ENVS.QA]: 'https://plangrid-dev.planfront.net/proxy/graphql/graphql',
    [ENVS.STAGING]: 'https://app.aus-stg.planfront.net/proxy/graphql/graphql',
    [ENVS.PRODUCTION]: 'https://app.plangrid.com.au/proxy/graphql/graphql',
  },
};

const cache = new InMemoryCache();

const env = getEnv();
const region = getRegion();
const httpLink = new HttpLink({
  uri: GRAPHQL_HOST[region][env],
  credentials: 'include',
});

const authLink = setContext((_, { headers }) =>
  getCurrentToken().then(({ accessToken }) => ({
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`,
      'x-requested-by': 'photo-entity-client',
    },
  })),
);

export default new ApolloClient({
  link: authLink.concat(httpLink),
  cache,
});
